import { render, staticRenderFns } from "./ViewClinicalSkillsGroupModal.vue?vue&type=template&id=1cb07eeb&scoped=true&"
import script from "./ViewClinicalSkillsGroupModal.vue?vue&type=script&lang=js&"
export * from "./ViewClinicalSkillsGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewClinicalSkillsGroupModal.vue?vue&type=style&index=0&id=1cb07eeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb07eeb",
  null
  
)

export default component.exports